module.exports = __webpack_public_path__ + "img/logo.7b8f6adb.png";